<template>
  <div v-if="currentUser && $route.params.serviceId" class="service-calendar-page">
    <ServiceModal :no-schedule-btn="true" />
    <CalendarUserModal @reloadCalendar="getServiceCalendar()" />

    <ModalVue
        :fields="[
        { name: 'dateInput', tag: 'input', req: true, type: 'date' },
        { name: 'timeInput', tag: 'input', req: true, type: 'time' }
      ]"
        title="wybierz element do usunięcia"
        button-text="usuń"
        :is-visible="isDeleteModalVisible"
        @closeModal="() => { isDeleteModalVisible = false }"
        @sendData="(data) => removeCalendarItem(data)"
    />

    <ModalVue
        :fields="[
        { name: 'dateInput', tag: 'input', req: true, type: 'date' },
        { name: 'timeInput', tag: 'input', req: true, type: 'time' }
      ]"
        title="wybierz wizytę do anulowania"
        button-text="anuluj"
        :is-visible="isCancelModalVisible"
        @closeModal="() => { isCancelModalVisible = false }"
        @sendData="(data) => cancelVisit(data)"
    />

    <div class="page-header">
      <h1>Kalendarz usługi {{ service?.name }}</h1>
    </div>

    <div class="section-card position-relative">
      <HintComponent page-key="business_panel_calendar_service_actions_list" :absolute="true" />
      <div class="action-buttons">
        <button class="btn btn-primary" @click="$router.push({ path: $route.path, query: { serviceID: $route.params.serviceId } })">Podgląd usługi</button>
        <button class="btn btn-neutral" @click="isAddingVisible = true">Dodaj element</button>
        <button class="btn btn-neutral" @click="isSerialAddingVisible = true">Dodaj elementy</button>
        <button class="btn btn-danger" @click="isDeleteModalVisible = true">Usuń element</button>
        <button class="btn btn-info" @click="isCancelModalVisible = true">Anuluj wizytę</button>
      </div>
    </div>

    <div class="section-card" v-if="isAddingVisible" ref="addCalendarItemForm">
      <div class="section-card-header">
        <h2>Dodawanie pojedynczego terminu</h2>
        <button class="icon-btn" @click="isAddingVisible = false">
          <img src="@/assets/icons/x.svg" alt="zamknij">
        </button>
      </div>

      <div class="single-add-grid">
        <input type="date" v-model="newCalendarItemDate">
        <div class="small-actions">
          <button class="btn btn-neutral" @click="timeFieldCount++">Dodaj pole godziny</button>
          <button class="btn btn-neutral" @click="() => { if (timeFieldCount > 1) timeFieldCount-- }">Odejmij pole godziny</button>
        </div>
        <input type="time" v-for="timeField in timeFieldCount" :key="timeField">
        <button class="btn btn-primary" @click="addCalendarItem">Zatwierdź</button>
      </div>
    </div>

    <div class="section-card" v-if="isSerialAddingVisible">
      <div class="section-card-header">
        <h2>Dodawanie seryjne</h2>
        <button class="icon-btn" @click="isSerialAddingVisible = false">
          <img src="@/assets/icons/x.svg" alt="zamknij">
        </button>
      </div>

      <div class="serial-table-wrap">
        <table class="serial-table">
          <thead>
          <tr>
            <th>pon.
              <div>
                <button @click="serialHours[0].push('')">+</button>
                <button @click="serialHours[0].pop()">-</button>
              </div>
            </th>
            <th>wt.
              <div>
                <button @click="serialHours[1].push('')">+</button>
                <button @click="serialHours[1].pop()">-</button>
              </div>
            </th>
            <th>śr.
              <div>
                <button @click="serialHours[2].push('')">+</button>
                <button @click="serialHours[2].pop()">-</button>
              </div>
            </th>
            <th>czw.
              <div>
                <button @click="serialHours[3].push('')">+</button>
                <button @click="serialHours[3].pop()">-</button>
              </div>
            </th>
            <th>pt.
              <div>
                <button @click="serialHours[4].push('')">+</button>
                <button @click="serialHours[4].pop()">-</button>
              </div>
            </th>
            <th>sob.
              <div>
                <button @click="serialHours[5].push('')">+</button>
                <button @click="serialHours[5].pop()">-</button>
              </div>
            </th>
            <th>niedz.
              <div>
                <button @click="serialHours[6].push('')">+</button>
                <button @click="serialHours[6].pop()">-</button>
              </div>
            </th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td v-for="x in 7" :key="x">
              <div class="hours-col">
                <input type="time" id="serialHourInput" :data-hourx="x" v-for="serialHour in serialHours[x-1].length" :key="serialHour">
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>

      <div class="repeatability">
        <span>Powtarzaj od tygodnia (włącznie):</span>
        <select name="AddSerialDateFrom" id="AddSerialDateFrom" v-model="serialAddRepeatabilityFrom">
          <option value="">-- wybierz tydzień --</option>
          <option :value="week.value" v-for="(week, index) in weeksList" :key="index">{{ week.text }}</option>
        </select>

        <span>Do tygodnia (włącznie):</span>
        <select name="AddSerialDateTo" id="AddSerialDateTo" v-model="serialAddRepeatabilityTo">
          <option value="">-- wybierz tydzień --</option>
          <option :value="week.value" v-for="(week, index) in weeksList" :key="index">{{ week.text }}</option>
        </select>

        <span v-if="serialAddLoading">Dodawanie elementów kalendarza ({{ dataToSendLeft.length }} / {{ serialToAddElems }})</span>
        <span v-if="serialAddError" class="sending-error">{{ serialAddError }}</span>
        <img class="sending-loading" src="@/assets/icons/loading.gif" v-if="serialAddLoading" alt="ładowanie">

        <button class="btn btn-primary" @click="addSerialCarendarItems" v-if="!serialAddLoading">Dodaj</button>
        <button class="btn btn-danger" @click="sendingSerialElementsStop = true" v-if="serialAddLoading">Anuluj</button>
      </div>
    </div>

    <div class="section-card position-relative">
      <HintComponent page-key="business_panel_calendar_visits_preview" :absolute="true" />
      <div class="view-controls">
        <select name="datesViewSelect" id="datesViewSelect" v-model="datesViewSelect" @change="setView">
          <option value="day">dzisiaj</option>
          <option value="sevenDays">7 dni do przodu</option>
          <option value="month">miesiąc</option>
          <option value="date">konkretna data</option>
        </select>

        <input type="date" name="viewDate" id="viewDate" v-model="viewDate" v-if="datesViewSelect === 'date'" @input="setView">

        <select name="viewMonth" id="viewMonth" v-if="datesViewSelect === 'month'" @change="setView" v-model="viewMonth">
          <option :value="new Date().toISOString().slice(0, 7)">{{ new Date().toISOString().slice(0, 7) }}</option>
          <option :value="new Date(new Date().setMonth(new Date().getMonth()+1)).toISOString().slice(0, 7)">{{ new Date(new Date().setMonth(new Date().getMonth()+1)).toISOString().slice(0, 7) }}</option>
          <option :value="new Date(new Date().setMonth(new Date().getMonth()+2)).toISOString().slice(0, 7)">{{ new Date(new Date().setMonth(new Date().getMonth()+2)).toISOString().slice(0, 7) }}</option>
          <option :value="new Date(new Date().setMonth(new Date().getMonth()+3)).toISOString().slice(0, 7)">{{ new Date(new Date().setMonth(new Date().getMonth()+3)).toISOString().slice(0, 7) }}</option>
          <option :value="new Date(new Date().setMonth(new Date().getMonth()+4)).toISOString().slice(0, 7)">{{ new Date(new Date().setMonth(new Date().getMonth()+4)).toISOString().slice(0, 7) }}</option>
          <option :value="new Date(new Date().setMonth(new Date().getMonth()+5)).toISOString().slice(0, 7)">{{ new Date(new Date().setMonth(new Date().getMonth()+5)).toISOString().slice(0, 7) }}</option>
          <option :value="new Date(new Date().setMonth(new Date().getMonth()+6)).toISOString().slice(0, 7)">{{ new Date(new Date().setMonth(new Date().getMonth()+6)).toISOString().slice(0, 7) }}</option>
          <option :value="new Date(new Date().setMonth(new Date().getMonth()+7)).toISOString().slice(0, 7)">{{ new Date(new Date().setMonth(new Date().getMonth()+7)).toISOString().slice(0, 7) }}</option>
          <option :value="new Date(new Date().setMonth(new Date().getMonth()+8)).toISOString().slice(0, 7)">{{ new Date(new Date().setMonth(new Date().getMonth()+8)).toISOString().slice(0, 7) }}</option>
          <option :value="new Date(new Date().setMonth(new Date().getMonth()+9)).toISOString().slice(0, 7)">{{ new Date(new Date().setMonth(new Date().getMonth()+9)).toISOString().slice(0, 7) }}</option>
          <option :value="new Date(new Date().setMonth(new Date().getMonth()+10)).toISOString().slice(0, 7)">{{ new Date(new Date().setMonth(new Date().getMonth()+10)).toISOString().slice(0, 7) }}</option>
          <option :value="new Date(new Date().setMonth(new Date().getMonth()+11)).toISOString().slice(0, 7)">{{ new Date(new Date().setMonth(new Date().getMonth()+11)).toISOString().slice(0, 7) }}</option>
        </select>
      </div>

      <div class="calendar-header">
        <h4 class="calendar-month-year">Podgląd terminów</h4>
      </div>

      <div class="service-calendar-table-wrap">
        <table class="service-calendar-table" ref="calendarTable" v-if="dates.length > 0 && datesViewSelect !== 'month'">
          <tr>
            <td>godzina</td>
            <td v-for="date in dates.slice(dates.indexOf(new Date().toJSON().slice(0, 10)), dates.indexOf(new Date().toJSON().slice(0, 10))+7)" :key="date">
              {{ date }}
            </td>
          </tr>
          <tr v-for="hour in hours" :key="hour">
            <td>{{ hour }}</td>
            <td
                v-for="date in dates.slice(dates.indexOf(new Date().toJSON().slice(0, 10)), dates.indexOf(new Date().toJSON().slice(0, 10))+7)"
                :key="date"
                :data-timeInfo="`${date}T${hour}`"
                @click="(e) => {
              if (e.target.dataset.user_id && e.target.dataset.pet_id && e.target.dataset.item_id && e.target.dataset.pd) {
                $router.push({ path: `/dla-biznesu/profile/calendar/${$route.params.serviceId}`, query: { userid: e.target.dataset.user_id, petid: e.target.dataset.pet_id, item_id: e.target.dataset.item_id, pd: e.target.dataset.pd } })
              }
            }"
            ></td>
          </tr>
        </table>

        <table class="service-calendar-table month-view" v-if="daysInMonth.length > 0 && datesViewSelect == 'month'" ref="monthTable" id="monthTable">
          <thead>
          <tr>
            <td v-for="(label, index) in monthDayLabels" :key="`h-${index}`">{{ label }}</td>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(week, weekIndex) in daysInMonth" :key="`w-${weekIndex}`">
            <td
                v-for="(day, dayIndex) in week"
                :key="`d-${weekIndex}-${dayIndex}`"
                :data-day="day || ''"
                :style="{ border: day && todaysDay === day ? '2px solid #f2790f' : '1px solid #e0e0e0' }"
            >
              <div v-if="day">{{ day }}<br></div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>

      <span class="calendar-info">Przesuń kalendarz w prawo lub lewo, aby zobaczyć więcej dni.</span>
    </div>

    <div class="section-card">
      <div class="legend">
        <span class="legend-item legend-item--empty">Brak elementu - termin nie został dodany na tą godzinę</span>
        <span class="legend-item legend-item--active">Element aktywny - termin dodany na tą godzinę, klient może się na niego zapisać</span>
        <span class="legend-item legend-item--reserved">Element zarezerwowany - termin dodany na tą godzinę, został już zarezerwowany przez klienta</span>
      </div>
    </div>
  </div>
</template>

<script>
import { useMeta } from 'vue-meta';
import ServiceModal from '@/components/SpecialComponents/ServiceModal.vue';
import CalendarUserModal from '@/components/SpecialComponents/CalendarUserModal.vue';
import ModalVue from '@/components/Modal.vue';
import axios from 'axios';
import authHeader from '@/services/auth-header';
import { useAuthStore } from '@/stores/auth';
import { useAppStore } from '@/stores/app';
import HintComponent from "@/components/SpecialComponents/HintComponent.vue";

export default {
  name: 'ServiceCalendar',
  setup() {
    useMeta({ title: 'Kalendarz usługi' });

    return {
      authStore: useAuthStore(),
      appStore: useAppStore(),
    };
  },
  data() {
    return {
      dates: [],
      hours: [],
      items: [],
      isAddingVisible: false,
      isSerialAddingVisible: false,
      timeFieldCount: 1,
      isDeleteModalVisible: false,
      newCalendarItemDate: '',
      datesViewSelect: 'month',
      viewDate: '',
      isCancelModalVisible: false,
      serialHours: [[], [], [], [], [], [], []],
      weeksList: [],
      serialAddRepeatabilityFrom: '',
      serialAddRepeatabilityTo: '',
      dataToSendLeft: [],
      serialAddLoading: false,
      serialToAddElems: 0,
      serialAddError: null,
      sendingSerialElementsStop: false,
      viewMonth: '',
      daysInMonth: [],
      todaysDay: '',
      monthDayLabels: ['pon.', 'wt.', 'śr.', 'czw.', 'pt.', 'sob.', 'niedz.'],
      service: null
    };
  },
  computed: {
    currentUser() {
      return this.authStore.user;
    }
  },
  created() {
    this.getService();
  },
  mounted() {
    this.viewMonth = this.formatLocalDate(new Date()).slice(0, 7);
    this.todaysDay = this.formatLocalDate(new Date());

    if (!this.currentUser) {
      this.$router.push('/login');
    } else if (this.currentUser.role_id !== 2) {
      this.$router.push('/login');
    }
    if (this.appStore.isSubscribed) {
      this.getServiceCalendar();
    } else {
      this.$router.push('/dla-biznesu/profile/user-data');
    }
    this.createWeeksList();
  },
  methods: {
    formatLocalDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return year + '-' + month + '-' + day;
    },
    getMonthMatrix(viewMonth) {
      const year = Number(viewMonth.split('-')[0]);
      const month = Number(viewMonth.split('-')[1]) - 1;

      const firstDay = new Date(year, month, 1);
      const daysInThisMonth = new Date(year, month + 1, 0).getDate();

      let mondayFirstOffset = firstDay.getDay() - 1;
      if (mondayFirstOffset < 0) {
        mondayFirstOffset = 6;
      }

      const flatDays = [];
      for (let i = 0; i < mondayFirstOffset; i++) {
        flatDays.push('');
      }

      for (let day = 1; day <= daysInThisMonth; day++) {
        flatDays.push(
            year + '-' + String(month + 1).padStart(2, '0') + '-' + String(day).padStart(2, '0')
        );
      }

      while (flatDays.length % 7 !== 0) {
        flatDays.push('');
      }

      const matrix = [];
      for (let i = 0; i < flatDays.length; i += 7) {
        matrix.push(flatDays.slice(i, i + 7));
      }

      return matrix;
    },
    addSerialCarendarItems() {
      document.querySelectorAll('#serialHourInput').forEach(elem => {
        this.serialHours[elem.dataset.hourx - 1].push(elem.value);
        this.serialHours[elem.dataset.hourx - 1].shift();
      });
      let errors = 7;
      this.serialHours.forEach(item => {
        if (item.length > 0) {
          errors = errors - 1;
        }
      });
      if (errors < 7 && this.serialAddRepeatabilityFrom && this.serialAddRepeatabilityTo) {
        let selectedSerialHoursOB = {};
        let howManyRepeatabilityDays = (new Date(this.serialAddRepeatabilityTo).getTime() - new Date(this.serialAddRepeatabilityFrom).getTime()) / (1000 * 60 * 60 * 24);
        const serialAddRepeatabilityFrom1 = new Date(this.serialAddRepeatabilityFrom);
        serialAddRepeatabilityFrom1.setDate(serialAddRepeatabilityFrom1.getDate() - 1);
        let dateFrom = new Date(serialAddRepeatabilityFrom1.toISOString());
        for (let x = 0; x < Math.ceil(howManyRepeatabilityDays / 7) + 1; x++) {
          this.serialHours.forEach((item) => {
            dateFrom.setDate(dateFrom.getDate() + 1);
            selectedSerialHoursOB[dateFrom.toISOString().split('T')[0]] = item;
          });
        }
        let filteredSelectedSerialHoursOB = {};
        for (const ob in selectedSerialHoursOB) {
          if (Object.keys(selectedSerialHoursOB[ob]).length > 0) {
            const filteredSelectedSerialHoursArr = [];
            Object.values(selectedSerialHoursOB[ob]).forEach(elem => {
              if (!filteredSelectedSerialHoursArr.includes(elem)) {
                filteredSelectedSerialHoursArr.push(elem);
              }
            });
            filteredSelectedSerialHoursOB[ob] = filteredSelectedSerialHoursArr;
          }
        }
        let dataToSend = [];
        for (const data in filteredSelectedSerialHoursOB) {
          dataToSend.push({
            date_from: data,
            date_to: data,
            hours: filteredSelectedSerialHoursOB[data],
            service_id: this.$route.params.serviceId
          });
        }
        const datesToCheck = [];
        this.items.forEach(calItem => {
          datesToCheck.push(calItem.date);
        });
        const compliantItems = dataToSend.filter(data => datesToCheck.includes(data.date_from));
        if (compliantItems.length > 0) {
          compliantItems.forEach(comItem => {
            delete dataToSend[dataToSend.indexOf(comItem)];
          });
        }
        this.dataToSendLeft = dataToSend;
        this.serialToAddElems = dataToSend.length;
        this.sendSerialElements();
      } else {
        this.appStore.setIsAlert('uzupełnij kalendarz chociaż jedną godziną i ustaw powtarzalność');
      }
    },
    sendSerialElements() {
      if (this.dataToSendLeft.length > 0 && !this.sendingSerialElementsStop) {
        this.serialAddLoading = true;
        axios.post('/CalendarItem', this.dataToSendLeft[0], authHeader()).then(res => {
          if (String(res.status).charAt(0) == '2') {
            this.dataToSendLeft.shift();
            setTimeout(() => {
              this.sendSerialElements();
            }, 1000);
          }
        }).catch(() => {
          this.dataToSendLeft.shift();
          this.serialAddError = `Nie dodano niektórych elementów!`;
          this.sendSerialElements();
        });
      } else {
        this.serialAddLoading = false;
        this.serialHours = [[], [], [], [], [], [], []];
        this.isSerialAddingVisible = false;
        this.serialAddRepeatabilityTo = '';
        this.serialAddRepeatabilityFrom = '';
        this.appStore.setIsSuccess('Pomyślnie dodano elementy');
        this.getServiceCalendar();
      }
    },
    createWeeksList() {
      const daysInTheWeek = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
      let currentDate = new Date();
      currentDate.setDate(new Date().getDate() + (7 - (daysInTheWeek.indexOf(new Date().toLocaleDateString('en-US', { weekday: 'long' })))));
      for (let x = 0; x < 50; x++) {
        let multiMondayFrom = new Date(currentDate);
        multiMondayFrom.setDate(multiMondayFrom.getDate() + (7 * x));
        let multiMondayTo = new Date(multiMondayFrom);
        multiMondayTo.setDate(multiMondayTo.getDate() + 7);
        this.weeksList.push({
          value: multiMondayFrom.toISOString().split('T')[0],
          text: `${multiMondayFrom.toISOString().split('T')[0]} - ${multiMondayTo.toISOString().split('T')[0]}`
        });
      }
    },
    fillCells() {
      setTimeout(() => {
        this.$refs.calendarTable?.querySelectorAll('td')?.forEach(el => {
          if (el.dataset.timeinfo) {
            if (this.items.filter(item => item.date == el.dataset.timeinfo.split('T')[0] && item.time == el.dataset.timeinfo.split('T')[1]).length > 0) {
              if (this.items.filter(item => item.date == el.dataset.timeinfo.split('T')[0] && item.time == el.dataset.timeinfo.split('T')[1])[0].user_id) {
                el.style = 'background-color: #f2790f; cursor: pointer; color: #fff; font-weight: 600;';
                el.dataset.user_id = this.items.filter(item => item.date == el.dataset.timeinfo.split('T')[0] && item.time == el.dataset.timeinfo.split('T')[1])[0].user_id;
                el.dataset.pet_id = this.items.filter(item => item.date == el.dataset.timeinfo.split('T')[0] && item.time == el.dataset.timeinfo.split('T')[1])[0].pet_id;
                el.dataset.item_id = this.items.filter(item => item.date == el.dataset.timeinfo.split('T')[0] && item.time == el.dataset.timeinfo.split('T')[1])[0].id;
                el.dataset.pd = Boolean(this.items.filter(item => item.date == el.dataset.timeinfo.split('T')[0] && item.time == el.dataset.timeinfo.split('T')[1])[0].payment_url &&
                    this.items.filter(item => item.date == el.dataset.timeinfo.split('T')[0] && item.time == el.dataset.timeinfo.split('T')[1])[0].payment_price);
                el.textContent = 'szczegóły';
              } else {
                el.style = 'background-color: #5ea01a; color: #fff;';
                el.dataset.user_id = null;
                el.dataset.pet_id = null;
                el.dataset.item_id = null;
                el.textContent = '';
              }
            } else {
              el.style = 'background-color: #bdbdbd;';
            }
          }
        });
      }, 100);
    },
    fillMonthCells() {
      setTimeout(() => {
        this.$refs.monthTable?.querySelectorAll('td')?.forEach(el => {
          el.querySelectorAll('a,span,br').forEach(elem => {
            elem.remove();
          });

          if (el.dataset.day) {
            const dayItems = this.items.filter(item => item.date === el.dataset.day);
            if (dayItems.length > 0) {
              dayItems.forEach(item => {
                if (item.user_id) {
                  const hour = document.createElement('a');
                  const br = document.createElement('br');
                  hour.style = 'color: #f2790f; font-weight: 600;';
                  hour.addEventListener('click', () => {
                    this.$router.push({
                      path: `/dla-biznesu/profile/calendar/${this.$route.params.serviceId}`,
                      query: {
                        userid: item.user_id,
                        petid: item.pet_id,
                        item_id: item.id,
                        pd: Boolean(item.payment_url && item.payment_price)
                      }
                    });
                  });
                  hour.setAttribute('href', '#monthTable');
                  hour.textContent = item.time;
                  el.appendChild(hour);
                  el.appendChild(br);
                } else {
                  const hour = document.createElement('span');
                  const br = document.createElement('br');
                  hour.style = 'color: #5ea01a; font-weight: 600;';
                  hour.textContent = item.time;
                  el.appendChild(hour);
                  el.appendChild(br);
                }
              });
            }
          }
        });
      }, 100);
    },
    addCalendarItem() {
      const timeFileds = this.$refs.addCalendarItemForm.querySelectorAll('input[type="time"]');
      if (this.newCalendarItemDate) {
        let timeValues = [];
        timeFileds.forEach(e => {
          if (e.value) {
            timeValues.push(e.value);
          }
        });
        if (timeValues.length < timeFileds.length) {
          this.appStore.setIsAlert('wypełnij wszystkie pola');
        } else {
          const checkSelectedDates = this.items.filter(item => item.date == this.newCalendarItemDate);
          checkSelectedDates.forEach(item => {
            timeValues.forEach(t => {
              if (t == item.time) {
                this.appStore.setIsAlert(`${t} jest już aktywna. Wybierz inną`);
                timeValues = timeValues.filter(time => time !== t);
              }
            });
          });
          if (timeValues == 0) {
            this.appStore.setIsAlert(`żadna godzina nie pasuje. Wybierz inną`);
          } else {
            const reqBody = {
              date_from: this.newCalendarItemDate,
              date_to: this.newCalendarItemDate,
              hours: timeValues,
              service_id: this.$route.params.serviceId
            };
            axios.post('/CalendarItem', reqBody, authHeader()).then(res => {
              if (String(res.status).charAt(0) == '2') {
                this.appStore.setIsSuccess('Pomyślnie dodano element');
                this.getServiceCalendar();
              }
            }).catch(() => {});
          }
        }
      } else {
        this.appStore.setIsAlert('wypełnij wszystkie pola');
      }
    },
    getServiceCalendar() {
      axios.get(`/CalendarItemsForService/${this.$route.params.serviceId}`).then(res => {
        this.items = res.data;
        this.dates = [];
        this.hours = [];
        this.dates.push(new Date().toJSON().slice(0, 10));
        this.items.forEach(e => {
          if (!this.hours.includes(e.time)) {
            this.hours.push(e.time);
          }
        });
        this.hours.sort((date1, date2) => date1.split(':')[0] - date2.split(':')[0]);
        this.setView();
      }).catch(() => {});
    },
    setView() {
      this.dates = [];

      if (this.datesViewSelect === 'sevenDays') {
        for (let x = 0; x < 7; x++) {
          this.dates.push(this.formatLocalDate(this.getNextDays(new Date(), x)));
        }
        this.fillCells();
        return;
      }

      if (this.datesViewSelect === 'day') {
        this.viewDate = '';
        this.dates.push(this.formatLocalDate(new Date()));
        this.fillCells();
        return;
      }

      if (this.datesViewSelect === 'date' && this.viewDate) {
        this.dates.push(this.viewDate);
        this.fillCells();
        return;
      }

      if (this.datesViewSelect === 'month' && this.viewMonth) {
        this.daysInMonth = this.getMonthMatrix(this.viewMonth);
        this.fillMonthCells();
      }
    },
    getNextDays(currentDate = new Date(), daysToAdd = 1) {
      const nextDate = new Date(currentDate);
      nextDate.setDate(currentDate.getDate() + daysToAdd);
      return nextDate;
    },
    removeCalendarItem(data) {
      if (this.items.filter(item => item.date == data.dateInput && item.time == data.timeInput).length > 0) {
        const itemToRemoveId = this.items.filter(item => item.date == data.dateInput && item.time == data.timeInput)[0].id;
        axios.delete(`/CalendarItem/${itemToRemoveId}`, authHeader()).then(res => {
          if (String(res.status).charAt(0) == '2') {
            this.appStore.setIsSuccess('Pomyślnie usunięto element');
            this.getServiceCalendar();
          }
        });
      } else {
        this.appStore.setIsAlert(`Nie ma takiego elementu`);
      }
    },
    cancelVisit(data) {
      if (this.items.filter(item => item.date == data.dateInput && item.time == data.timeInput).length > 0) {
        if (this.items.filter(item => item.date == data.dateInput && item.time == data.timeInput)[0].user_id) {
          const itemToCancelId = this.items.filter(item => item.date == data.dateInput && item.time == data.timeInput)[0].id;
          const itemToCancelUserId = this.items.filter(item => item.date == data.dateInput && item.time == data.timeInput)[0].user_id;
          axios.post('/CalendarItemRemoveUser', {
            calendar_id: itemToCancelId,
            user_id: itemToCancelUserId,
            employee_id: 0
          }, authHeader()).then(res => {
            if (String(res.status).charAt(0) == '2') {
              this.appStore.setIsSuccess('anulowano wizytę');
              this.getServiceCalendar();
            }
          }).catch(() => {});
        } else {
          this.appStore.setIsAlert(`Nikt nie jest umówiony na ten termin`);
        }
      } else {
        this.appStore.setIsAlert(`Nie ma takiego elementu`);
      }
    },
    getService() {
      const serviceId = this.$route.params.serviceId;
      axios.get(`/Service/${serviceId}`, authHeader()).then(res => {
        this.service = res.data;
      }).catch(() => {});
    }
  },
  components: {HintComponent, ServiceModal, CalendarUserModal, ModalVue }
};
</script>

<style scoped lang='scss'>
.service-calendar-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 24px 16px 32px;
  box-sizing: border-box;
  font-family: sans-serif;
  color: #1f2937;
}

.page-header {
  margin-bottom: 20px;
  padding-bottom: 14px;
  border-bottom: 2px solid #e5e7eb;
}

.page-header h1 {
  margin: 0;
  font-size: 2.8rem;
  font-weight: 700;
}

.section-card {
  width: 100%;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,.08);
  padding: 16px;
  margin-bottom: 16px;
  box-sizing: border-box;
}

.section-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 10px;
}

.section-card-header h2 {
  margin: 0;
  font-size: 2rem;
}

.action-buttons {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.btn {
  border: none;
  border-radius: 8px;
  padding: 10px 14px;
  font-size: 1.4rem;
  cursor: pointer;
  transition: all .2s ease-in-out;
}

.btn-primary {
  background: #f2790f;
  color: #fff;
}
.btn-primary:hover { background: #d66a0a; }

.btn-neutral {
  background: #e5e7eb;
  color: #1f2937;
}
.btn-neutral:hover { background: #d1d5db; }

.btn-danger {
  background: #bb2d3b;
  color: #fff;
}
.btn-danger:hover { background: #991b1b; }

.btn-info {
  background: #0b5ed7;
  color: #fff;
}
.btn-info:hover { background: #084298; }

.icon-btn {
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 4px;
}
.icon-btn img {
  width: 24px;
  height: 24px;
}

.single-add-grid {
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-width: 420px;
}

.single-add-grid input {
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 1.4rem;
  outline: none;
}
.single-add-grid input:focus { border-color: #f2790f; }

.small-actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.serial-table-wrap {
  overflow-x: auto;
}

.serial-table {
  width: 100%;
  min-width: 900px;
  border-collapse: separate;
  border-spacing: 0;
}
.serial-table th {
  text-align: center;
  padding: 10px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  font-size: 1.4rem;
}
.serial-table th div {
  margin-top: 6px;
}
.serial-table th button {
  margin: 0 4px;
  border: none;
  width: 28px;
  height: 28px;
  border-radius: 6px;
  cursor: pointer;
  background: #e5e7eb;
}
.serial-table td {
  border: 1px solid #e5e7eb;
  vertical-align: top;
}
.hours-col {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 10px;
}
.hours-col input {
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 8px;
}

.repeatability {
  margin-top: 14px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 520px;
}
.repeatability select,
.repeatability button {
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 10px 12px;
}
.repeatability .sending-error {
  color: #bb2d3b;
  font-weight: 600;
}
.sending-loading {
  width: 36px;
}

.view-controls {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 12px;
}
.view-controls select,
.view-controls input {
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 1.4rem;
}

.calendar-header {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 14px;
  padding-bottom: 12px;
  border-bottom: 2px solid #f0f0f0;
}
.calendar-month-year {
  margin: 0;
  font-size: 2rem;
  font-weight: 600;
  color: #333;
}

.service-calendar-table-wrap {
  width: 100%;
  overflow: auto;
  border-radius: 10px;
  border: 1px solid #e5e7eb;
}

.service-calendar-table {
  width: 100%;
  min-width: 1100px;
  border-collapse: collapse;
  background: #fff;
}
.service-calendar-table tr td {
  border: 1px solid #e5e7eb;
  padding: 6px 8px;
  font-size: 1.3rem;
  min-width: 130px;
  text-align: center;
}
.service-calendar-table tr td:first-child {
  background: #f9fafb;
  font-weight: 600;
  min-width: 90px;
}

.month-view td {
  min-width: 150px;
  height: 90px;
  vertical-align: top;
  text-align: left !important;
}

.calendar-info {
  display: none;
  font-size: 12px;
  color: #666;
  margin-top: 10px;
  text-align: right;
}

.legend {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.legend-item {
  font-size: 1.4rem;
  font-weight: bold;
}
.legend-item--empty { color: #8b8b8b; }
.legend-item--active { color: #5ea01a; }
.legend-item--reserved { color: #f2790f; }

@media (max-width: 768px) {
  .page-header h1 { font-size: 2.2rem; }
  .section-card-header h2 { font-size: 1.8rem; }

  .calendar-info {
    display: block;
  }

  .btn {
    width: 100%;
  }
}
</style>